import React from "react";

export const HyperLinkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="28">
      <g fill="none" fillRule="evenodd">
        <rect width="36" height="28" fill="#3D6FCF" rx="4"></rect>
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M22 14.667v4c0 .736-.597 1.333-1.333 1.333h-7.334A1.333 1.333 0 0112 18.667v-7.334c0-.736.597-1.333 1.333-1.333h4M20 8h4v4m-7.333 3.333L24 8"
        ></path>
      </g>
    </svg>
  );
};
